export enum CompanyType {
    ALL = 'all',
    TITLE = 'title',
    ABSTRACT = 'abstract',
    SETTLEMENT = 'settlement',
    ESCROW = 'escrow',
    ATTORNEY = 'attorney'
}

export const getCompanyTypeText = (type: CompanyType): string => {
  switch (type) {
  case CompanyType.ALL:
    return 'All Types';
  case CompanyType.TITLE:
    return 'Title';
  case CompanyType.ABSTRACT:
    return 'Abstract';
  case CompanyType.SETTLEMENT:
    return 'Settlement';
  case CompanyType.ESCROW:
    return 'Escrow';
  case CompanyType.ATTORNEY:
    return 'Attorney';
  default:
    return 'Unknown';
  }
}

export const getCompanyTypeOptions = () => {
  return Object.values(CompanyType)
    .filter(value => value !== CompanyType.ALL)
    .map(value => ({key: value, text: getCompanyTypeText(value), value: value}));
}